import { render, staticRenderFns } from "./EditWebHook.vue?vue&type=template&id=47bf7fd6"
import script from "./EditWebHook.vue?vue&type=script&lang=js"
export * from "./EditWebHook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports